import { ChatHandler } from "./handlers/chat/actions-handler";
import { AccessHandler } from "./handlers/location/access-handler";
import { ClearSceneHandler } from "./handlers/location/clear-scene-handler";
import { FurnitureActionsHandler } from "./handlers/location/furniture-actions-handler";
import { LocationActionsHandlers } from "./handlers/location/location-actions-handler";
import { NPCHandler } from "./handlers/location/npc-handler";
import { OutfitActionsHandler } from "./handlers/player/outfit-actions-handler";
import { PathfinderHandler } from "./handlers/player/pathfinder-handler";

// Function to register all handlers
export function registerClientHandlers() {
  // Chat
  HandlerRegistry.registerHandler("chat", ChatHandler);

  // Location
  HandlerRegistry.registerHandler("location-access", AccessHandler);
  HandlerRegistry.registerHandler("clear-scene", ClearSceneHandler);

  HandlerRegistry.registerHandler("furniture-actions", FurnitureActionsHandler);
  HandlerRegistry.registerHandler("location-actions", LocationActionsHandlers);

  // Player
  HandlerRegistry.registerHandler("pathfinder", PathfinderHandler);
  HandlerRegistry.registerHandler("outfit-actions", OutfitActionsHandler);

  HandlerRegistry.registerHandler("npcs", NPCHandler);
}

export class HandlerRegistry {
  static handlers = {};

  // Register a handler for a specific message type
  static registerHandler(type, handler) {
    if (typeof handler.handle !== "function") {
      throw new Error(
        `Handler for type "${type}" must implement a static "handle" method.`
      );
    }
    HandlerRegistry.handlers[type] = handler;
  }

  // Handle a message dynamically
  static handleMessage(message) {
    try {

      if (message === "UKNOWN_COMMAND") {
        console.error("Uknown command");
        return;
      }

      const data = JSON.parse(message); // Parse the incoming JSON message
      if (!data.type) {
        console.warn("Message does not contain a 'type' field:", data);
        return;
      }

      const handler = HandlerRegistry.handlers[data.type];
      if (!handler) {
        console.warn(`No handler registered for message type: "${data.type}"`);
        return;
      }

      handler.handle(data); // Delegate to the specific handler
    } catch (error) {
      console.error("Error processing received message:", error, message);
    }
  }
}
